<template>
  <button
    class="follow-button"
    :class="{ following: isFollowing }"
    @click.stop="setFollowing"
  >
    <div class="icon-container">
      <icon
        class="button-icon"
        :name="icon"
        :variant="iconVariant"
      />
    </div>
    {{ buttonText }}
  </button>
</template>

<script>
import Icon from '@components/singletons/icon';
export default {
  components: {Icon},
  props: {
    contentPartnerId: {
      type: Number,
    },
  },
  computed: {
    buttonText() {
      return this.isFollowing ? 'Following' : 'Follow';
    },
    icon() {
      return this.isFollowing ? 'check' : 'cross-thin';
    },
    iconVariant() {
      return this.isFollowing ? 'white' : 'mastery';
    },
    contentFollow() {
      return this.$store.getters['user/contentFollows']?.find(follow => follow.contentPartnerId === this.contentPartnerId);
    },
    isFollowing() {
      return !!this.contentFollow;
    },
  },
  methods: {
    setFollowing() {
      if (this.isFollowing) {
        this.$store.dispatch('user/unfollowContentPartner', this.contentFollow.id);
      } else {
        this.$store.dispatch('user/followContentPartner', this.contentPartnerId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-button {
  background: transparent;
  border: 1px solid #dedede;
  display: flex;
  align-items: center;
  padding: 0 8px 0 0;
  text-transform: uppercase;
  font-size: rem-calc(12);
  font-weight: $semi-bold;
  height: rem-calc(24);

  .icon-container {
    height: 100%;
    width: rem-calc(24);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: rem-calc(8);

    .button-icon {
      transform: rotate(45deg);
      width: rem-calc(12);
    }
  }


  &.following {
    border-color: #00dbfb;

    .icon-container {
      background-color: #00dbfb;

      .button-icon {
        transform: rotate(0);
        width: rem-calc(16);
      }
    }
  }
}
</style>